import i18n from 'i18next';
import { call, put } from 'redux-saga/effects';
import { deleteAccountFailure, deleteAccountSuccess } from '../actions';
import { deleteAccount } from '../api';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* deleteAccountSaga() {
  try {
    let err: ApiError | null;

    const response: ApiResponse = yield call(deleteAccount);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: i18n.t('notifications.owner-deleted-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(deleteAccountSuccess());
    yield put(logoutRequest());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(deleteAccountFailure());
  }
}
